export default __webpack_public_path__ + "static/logo-coin-b85e332e458e42f37cfba835b4bc256d.svg";